/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string, number, oneOfType,
    bool, arrayOf, func, object,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '@material-ui/core/Button';
import { bindActionCreators } from 'redux';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import configENV from '../../../../config';

const { PERSIST_KEY } = configENV;

class ShopTheSite extends React.Component {
    handleShopTheSiteButtonClicked = (recipient) => {
        const {
            remainingRecipient,
            location: { pathname: giftListURL },
            noShopTheSiteConfirmation,
            handleConfirmGiftListShopTheSiteClicked,
            handleGiftListShopTheSiteClicked,
        } = this.props;
        const recipientWithCounter = { ...recipient, remainingRecipient, giftListURL };

        if (noShopTheSiteConfirmation) {
            handleConfirmGiftListShopTheSiteClicked(
                recipientWithCounter,
                '/',
                true,
            );
        } else {
            handleGiftListShopTheSiteClicked(recipientWithCounter);
        }
    };

    render() {
        const { customClass } = this.props;
        const {
            recipient,
            addToCart,
            customButtonClass,
            handleGiftListEnterItemNumberClicked,
            track,
        } = this.props;

        if (addToCart) return null;

        const recipientNoError = recipient;
        recipientNoError.error = {};
        return (
            <>
                <div
                    className={`shop-the-site-wrapper align-center no-margin-bottom margin-top-2x ${customClass}`}
                >
                    <h2 className="normal">Find another gift for {recipient.firstname} {recipient.lastname}</h2>
                    <div className="split">
                        <Button
                            variant="contained"
                            className={`${customButtonClass} margin-bottom narrow-button small-text shop-the-site-button`}
                            onClick={() => {
                                track({
                                    eventCategory: 'GiftList',
                                    eventAction: 'Shop The Site',
                                    eventLabel: '',
                                });
                                this.handleShopTheSiteButtonClicked(recipientNoError);
                            }}
                        >
                            Shop The Site
                        </Button>
                        <Button
                            variant="contained"
                            className={`${customButtonClass} margin-bottom narrow-button small-text enter-item-number-button`}
                            onClick={() => {
                                track({
                                    eventCategory: 'GiftList',
                                    eventAction: 'Enter Item Number',
                                    eventLabel: '',

                                    ga_event_name: 'gift_list_interaction',
                                    interaction_type: 'add_item',
                                });
                                handleGiftListEnterItemNumberClicked(recipientNoError);
                            }}
                        >
                            Enter Item #
                        </Button>
                    </div>
                </div>
            </>
        );
    }
}

ShopTheSite.defaultProps = {
    customClass: '',
    customButtonClass: '',
    location: {},
    addToCart: '',
    recipient: {},
    noShopTheSiteConfirmation: false,
};

ShopTheSite.propTypes = {
    recipient: shape({
        AddressBookEntryId: string,
        addToCart: string,
        address: shape({
            addressId: string,
            apt: string,
            city: string,
            company: string,
            country: shape({
                id: string,
                name: string,
            }),
            location: shape({
                id: number,
                name: string,
            }),
            state: shape({
                id: string,
                name: string,
            }),
            street: string,
            zipcode: string,
        }),
        addressId: string,
        firstname: string,
        giftArrived: string,
        id: string,
        isNewRecipient: bool,
        lastname: string,
        occasionId: string,
        orderItemId: string,
        products: arrayOf(
            shape({
                content: string,
                crossedPrice: oneOfType([number, string]),
                discountPrice: oneOfType([number, string]),
                id: string,
                image: string,
                name: string,
                parentCatalogEntryId: string,
                partNumber: string,
                price: number,
                seoproductDisplayURL: string,
                sku: string,
                status: string,
            }),
        ),
        type: string,
    }),
    customClass: string,
    addToCart: string,
    location: object,
    customButtonClass: string,
    remainingRecipient: number.isRequired,
    noShopTheSiteConfirmation: bool,
    handleGiftListShopTheSiteClicked: func.isRequired,
    handleConfirmGiftListShopTheSiteClicked: func.isRequired,
    handleGiftListEnterItemNumberClicked: func.isRequired,
    track: func.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    // console.log('ShopTheSite - newState', newState);
    return {
        toggleState: newState.toggleState,
        remainingRecipient: newState.giftList.remainingRecipient,
        noShopTheSiteConfirmation: newState.giftList.noShopTheSiteConfirmation,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListShopTheSiteClicked: (recipient) => dispatch(EventDispatcher.handleGiftListShopTheSiteClicked(recipient)),
    handleConfirmGiftListShopTheSiteClicked: (recipient, url, dontShowModal) => dispatch(EventDispatcher.handleConfirmGiftListShopTheSiteClicked(
        recipient,
        url,
        dontShowModal,
    )),
    handleGiftListEnterItemNumberClicked: (recipient) => dispatch(EventDispatcher.handleGiftListEnterItemNumberClicked(recipient)),
    track: bindActionCreators(trackEvent, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(ShopTheSite));
